import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-calander',
  templateUrl: './leave-calander.component.html',
  styleUrls: ['./leave-calander.component.css']
})
export class LeaveCalanderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
